<template>
  <select v-model="itemModel" ref="selectRoot">

    <!-- Default Item -->
    <option
      disabled
      value=""
    >
      {{ defaultItem }}
    </option>

    <!-- Available Item Options -->
    <option
      v-for="(item, index) in itemList"
      :key="index"
    >
      {{ item }}
    </option>

  </select>
</template>

<script>
export default {
  name: 'Selector',
  props: {
    itemList: { type: Array, default: () => [] },
    selectedItem: { type: String, default: '' },
    defaultItem: { type: String, default: 'Select a Series' }
  },
  computed: {
    itemModel: {
      get() {
        return this.selectedItem;
      },
      set(value) {
        this.$emit('change', value);
        this.$forceUpdate(); // Required to reset selected value
      }
    }
  }
}
</script>

<style scoped>

</style>